import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  ButtonToolbar,
  ButtonGroup,
  Button,
} from 'react-bootstrap';

class TourHotelSendToolbar extends Component {

  render() {
    return (
      // <ButtonToolbar>
      //   <ButtonGroup>
      //     <Button
      //       onClick={this.props.showRoomPrefs}
      //       bsStyle="info"
      //       title="Set room count and any special requests"
      //     >
      //       <i className="fa fa-hotel fa-lg" /> Bid Details
      //     </Button>
      //   </ButtonGroup>
      // </ButtonToolbar>
      <div></div>
    );
  }
}
TourHotelSendToolbar.propTypes = {
  showRoomPrefs: PropTypes.func.isRequired,
};

export default TourHotelSendToolbar;



// WEBPACK FOOTER //
// src/routes/tours/components/TourHotelSendToolbar.js